"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManipulatorHandlerStateBase = void 0;
var fixed_1 = require("@devexpress/utils/lib/intervals/fixed");
var ManipulatorHandlerStateBase = (function () {
    function ManipulatorHandlerStateBase(handler) {
        this.handler = handler;
    }
    ManipulatorHandlerStateBase.prototype.start = function () { };
    ManipulatorHandlerStateBase.prototype.finish = function () { };
    ManipulatorHandlerStateBase.prototype.dispose = function () { };
    ManipulatorHandlerStateBase.prototype.resizeRotationChecker = function (action) {
        var activeSubDocument = this.handler.control.selection.activeSubDocument;
        var specRunInfo = this.handler.control.selection.specialRunInfo;
        var subDoc = activeSubDocument.isTextBox() ?
            specRunInfo.getParentSubDocument() :
            activeSubDocument;
        var intervals = activeSubDocument.isTextBox() ?
            [new fixed_1.FixedInterval(specRunInfo.getTextBoxPosition(), 1)] :
            this.handler.control.selection.intervals;
        if (subDoc.isEditable(intervals)) {
            if (!this.handler.control.isReadOnlyPersistent)
                action();
            return true;
        }
        return false;
    };
    return ManipulatorHandlerStateBase;
}());
exports.ManipulatorHandlerStateBase = ManipulatorHandlerStateBase;
